<template>
  <v-card rounded="lg" class="pt-0">
    <v-form v-model="valid" ref="form" lazy-validation>
      <!-- Impresa / Referente -->
      <v-card-text class="pt-2">
        <v-row>
          <v-col sm="10" md="7">
            <!-- <p class="text-subtitle-1 font-weight-medium">Impresa</p> -->
            <v-list two-line subheader>
              <v-list-item>
                <v-list-item-avatar color="grey lighten-2" dark>
                  <v-icon> mdi-domain </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Impresa</v-list-item-title>
                  <v-list-item-subtitle>Informazioni sull'impresa</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <div class="text-body-1 ml-16 pl-2">
              <template v-if="editMode">
                <v-text-field
                  v-model="form.company.name"
                  label="Ragione sociale*"
                  required
                  :rules="[rules.required]"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="form.company.address"
                  label="Indirizzo*"
                  required
                  :rules="[rules.required]"
                  outlined
                  dense
                ></v-text-field>
                <v-row no-gutters>
                  <v-col>
                    <search-place-field
                      v-model="form.company.city"
                      locale="IT"
                      label="Comune*"
                      required
                      :rules="[rules.required]"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col md="3" class="pl-md-3"
                    ><v-text-field
                      v-model="form.company.zip"
                      label="CAP*"
                      maxlength="5"
                      required
                      :rules="[rules.required]"
                      outlined
                      dense
                  /></v-col>
                </v-row>

                <search-ateco-field
                  label="Attività economica prevalente (ATECO)*"
                  v-model="form.company.ateco"
                  required
                  :rules="[rules.required]"
                  outlined
                  dense
                  hint="Inserisci un testo o il codice nel formato XX.XX (es: 10.01, 13.10, ecc.)"
                  persistent-hint
                />
              </template>
              <template v-else>
                {{ form.company.name }} <br />
                {{ form.company.address }} <br />
                {{ form.company.zip }} {{ form.company.city }} <br />
                {{ form.company.ateco }}
              </template>
            </div>
            <div class="text-body-1"></div>
          </v-col>

          <v-col sm="7" md="5">
            <!-- <p class="text-subtitle-1 font-weight-medium">Referente</p> -->
            <v-list two-line subheader>
              <v-list-item>
                <v-list-item-avatar color="grey lighten-2" dark>
                  <v-icon> mdi-account </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Referente</v-list-item-title>
                  <v-list-item-subtitle>Persona da contattare per eventuali chiarimenti</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div class="text-body-1 ml-16 pl-2">
              <template v-if="editMode">
                <v-text-field
                  v-model="form.referent.name"
                  label="Nominativo*"
                  required
                  :rules="[rules.required]"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="form.referent.email"
                  type="email"
                  label="Email*"
                  required
                  :rules="[rules.required, rules.email]"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="form.referent.phone"
                  label="Telefono*"
                  required
                  :rules="[rules.required]"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <template v-else>
                {{ form.referent.name }} <br />
                {{ form.referent.email }} <br />
                {{ form.referent.phone }}
              </template>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Parco automezzi -->
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th width="65%">
                <!-- <span class="text-subtitle-1 font-weight-medium">Parco automezzi</span>
                <span class="font-weight-regular text--secondary font-caption ml-1"
                  >&nbsp;al 1 Gennaio {{ form.year }}</span
                > -->
                <v-list two-line subheader class="font-weight-regular mb-0 pb-0">
                  <v-list-item>
                    <v-list-item-avatar color="grey lighten-2" dark>
                      <v-icon> mdi-train-car </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>Parco automezzi</v-list-item-title>
                      <v-list-item-subtitle>al 1 Gennaio {{ form.year }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </th>
              <th v-for="name in vehicleFleetCounters" :key="name" class="text-subtitle-2 text-center">
                {{ vehicleFleetLabels[name] }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in vehicleFleetItems" :key="item">
              <td>
                <span class="pl-16 ml-md-2">{{ vehicleFleetLabels[item] }}</span>
              </td>
              <td v-for="counter in vehicleFleetCounters" :key="`${item}_${counter}`" class="text-center">
                <template v-if="editMode">
                  <v-text-field
                    v-model.number="form.fleet[item][counter]"
                    type="number"
                    :min="0"
                    dense
                    outlined
                    hide-details
                    :rules="[rules.required, rules.min(0)]"
                    required
                    class="input-text-center"
                  />
                </template>
                <template v-else>
                  {{ form.fleet[item][counter] }}
                </template>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <v-divider></v-divider>

      <!-- Proprietà automezzo -->
      <v-card-text>
        <v-row no-gutters>
          <v-col md="4">
            <!-- <span class="text-subtitle-1">Proprietà automezzo</span> -->
            <v-list two-line subheader class="font-weight-regular mb-0 pb-0">
              <v-list-item>
                <v-list-item-avatar color="grey lighten-2" dark>
                  <v-icon> mdi-key-chain-variant </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Proprietà automezzo</v-list-item-title>
                  <v-list-item-subtitle>nel periodo di rilevazione</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <template v-if="editMode">
            <v-col>
              <v-switch
                v-model="form.ownership.changed"
                label="Il veicolo non è più di nostra proprietà"
                class="mt-0"
              ></v-switch>
            </v-col>
            <v-col md="2" v-if="form.ownership.changed">
              <v-select
                v-model.lazy="form.ownership.reason"
                :items="vehicleOwnershipChangedOptions"
                label="Motivo"
                :rules="[rules.required]"
                required
                :disabled="!form.ownership.changed"
                outlined
                dense
              />
            </v-col>
            <v-col md="2" v-if="form.ownership.changed" class="pl-md-4">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.ownership.date"
                    label="Data"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :disabled="!form.ownership.changed"
                    required
                    :rules="[rules.required]"
                    outlined
                    dense
                  >
                    <template #prepend>
                      <span class="pt-1">Dal</span>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="form.ownership.date"
                  @input="menu2 = false"
                  :rules="[rules.required]"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </template>
          <template v-else>
            <v-col>
              <span class="text-body-1" v-text="ownershipText"></span>
            </v-col>
          </template>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Attività automezzo -->
      <v-card-text>
        <v-row no-gutters>
          <v-col md="4">
            <!-- <span class="text-subtitle-1">Attività automezzo</span><br />
            <small class="text-caption text--secondary">nel periodo di rilevamento</small> -->
            <v-list two-line subheader class="font-weight-regular mb-0 pb-0">
              <v-list-item>
                <v-list-item-avatar color="grey lighten-2" dark>
                  <v-icon> mdi-arrow-decision-auto </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Attività automezzo</v-list-item-title>
                  <v-list-item-subtitle>nel periodo di rilevamento</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <template v-if="editMode">
            <v-col class="text-body-1">
              <v-switch v-model="form.vehicle_stopped" label="Automezzo è stato fermo" class="mt-0" hide-details />
            </v-col>
            <v-col md="4">
              <v-text-field
                v-model.number="form.vehicle_fuel_consumed"
                type="number"
                label="Carburante consumato"
                placeholder=" "
                required
                :min="0"
                :rules="[rules.required, rules.min(0)]"
                prepend-inner-icon="mdi-gas-station"
                suffix="litri"
                outlined
                dense
                :disabled="form.vehicle_stopped"
                style="width: 180px"
              />
            </v-col>
          </template>
          <template v-else>
            <v-col>
              <span class="text-body-1" v-text="activityText"></span>
            </v-col>
          </template>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <template v-if="editMode">
          <v-btn text color="primary" @click="editMode = !editMode" x-large class="rounded-lg">Annulla</v-btn>
          <v-btn text color="primary" @click="onSubmit" x-large class="rounded-lg">Continua</v-btn>
        </template>
        <template v-else>
          <v-btn text color="primary" @click="editMode = !editMode" x-large class="rounded-lg">Modifica</v-btn>
        </template>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
// Components
import SearchPlaceField from './SearchPlaceField.vue'
import SearchAtecoField from './SearchAtecoField.vue'

// Validations
import { required, email, phoneNumber, min } from '@/validations'

// Helpers
import { clone } from '@/helpers'

// Component
export default {
  name: 'EditSurveyForm',
  components: {
    SearchAtecoField,
    SearchPlaceField,
  },
  props: {
    value: {
      type: Object,
    },
    readOnly: {
      type: Boolean,
      dafault: false,
    },
  },
  data() {
    return {
      dialog: false,
      menu1: false,
      menu2: false,
      valid: true,
      editMode: true,

      ateco: null,

      vehicleFleetLabels: {
        owned: 'Proprietà',
        leasing: 'Leasing',
        rent: 'Locazione',
        vehicles: 'Nr. Automezzi con portata utile ≥ 35q',
        tractors: 'Nr. Trattori stradali',
        trailers: 'Nr. Rimorchi',
        semitrailers: 'Nr. Semirimorchi',
      },
      vehicleFleetCounters: ['owned', 'leasing', 'rent'],
      vehicleFleetItems: ['vehicles', 'tractors', 'trailers', 'semitrailers'],

      vehicleOwnershipChangedOptions: [
        { value: 1, text: 'Venduto' },
        { value: 2, text: 'Ceduto' },
        { value: 3, text: 'Locato' },
        { value: 4, text: 'Rottamato' },
        { value: 5, text: 'Sequestrato' },
        { value: 6, text: 'Rubato' },
      ],

      form: {
        // Impresa
        company: {
          city: null,
          address: '',
          name: '',
          ateco: null,
          zip: '',
        },

        // Referente
        referent: {
          name: '',
          phone: '',
          email: '',
        },

        // Parco automezzi
        fleet: {
          vehicles: { owned: 0, leasing: 0, rent: 0 },
          tractors: { owned: 0, leasing: 0, rent: 0 },
          trailers: { owned: 0, leasing: 0, rent: 0 },
          semitrailers: { owned: 0, leasing: 0, rent: 0 },
        },

        // Proprietà automezzo
        ownership: {
          changed: null,
          reason: null,
          date: null,
        },

        vehicle_stopped: null,
        vehicle_fuel_consumed: null,
      },

      rules: {
        required,
        email,
        min,
        phoneNumber,
      },
    }
  },
  mounted() {
    this.editMode = !this.readOnly
    const { company, referent, fleet, vehicle, ownership, vehicle_stopped, vehicle_fuel_consumed } = this.value

    this.form = clone({ company, referent, fleet, vehicle, ownership, vehicle_stopped, vehicle_fuel_consumed })
  },
  computed: {
    ownershipText() {
      if (!this.form.ownership.changed) return 'Di proprietà'

      const { reason, date } = this.form.ownership
      const { text } = this.vehicleOwnershipChangedOptions.find((o) => o.value === reason)

      return `${text} in data ${date}`
    },
    activityText() {
      if (this.form.vehicle_stopped) return 'Fermo'

      return `Carburante consumato: ${this.form.vehicle_fuel_consumed} litri`
    },
  },
  methods: {
    clear() {
      if (this.form.vehicle_stopped) {
        this.form.vehicle_fuel_consumed = 0
      }

      if (!this.form.ownership.changed) {
        this.form.ownership.reason = null
        this.form.ownership.date = null
      }
    },
    async onSubmit() {
      this.clear()
      await this.$refs.form.validate()

      if (this.valid) {
        this.$emit('submit', this.form)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .input-text-center input[type='number'] {
  text-align: center;
}
</style>
